import EditOrderContainer from './EditOrderContainer';

export default EditOrderContainer;
